var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoDigital(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 212.26 172.88",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#9ca5ad;}.cls-2{fill:#505050;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vectors"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M25.91,35.58h0A15.52,15.52,0,0,1,4.35,31.73C-3.63,20.06,1.83,8,1.73,0,6,7.5,23,4.38,29.77,14A15.52,15.52,0,0,1,25.91,35.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M31.59,54.71c.27,0,.24.3.52.33A10.47,10.47,0,0,1,34.64,69.5a11.27,11.27,0,0,1-6.14,4.38c-6.15,1.36-8.28-2.39-12.52,5.17.22-5.45-3.45-13.45,1.63-21.21A10.11,10.11,0,0,1,31.59,54.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M49.9,42.94a1.53,1.53,0,0,1-1.51,1.51c-8.27.63-16-1.71-23.41-7.58A58.12,58.12,0,0,1,9.65,18.51a1.78,1.78,0,0,1,3.16-1.63h0A57.37,57.37,0,0,0,27.15,34.05c6.64,5.25,13.56,7.52,21,6.82A1.6,1.6,0,0,1,50,42.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M44.14,43a1.49,1.49,0,0,1-.93,1.29c-4.3,2.08-7.77,7.24-9.77,11.17a30.36,30.36,0,0,0-2.39,5.26,1.72,1.72,0,1,1-3.16-1.38S29,56.67,30.6,53.53c2.32-4.45,6-9.78,10.83-12.08.86-.47,2.37-.7,2.84.17A2.13,2.13,0,0,0,44.14,43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M131.19,98.15s10,5.39,17.33,19.18c8.36,15.73,9.22,45.37,9.22,45.37l-7.27,2.52s2.57-25.09-6.3-43.44C136,104.81,124.85,101,124.85,101Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 192.46,
    y: 141.21,
    width: 5.01,
    height: 14.62,
    transform: "translate(205.4 -96.35) rotate(55.14)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 194.31,
    y: 142.04,
    width: 9.76,
    height: 25.08,
    transform: "translate(212.19 -97.22) rotate(55.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M119.2,55.2c-31.31-15-47.46-17.68-72.51-18.06l.21,10.8c22.55.66,42.06,6,66.6,19.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M204,139.21l-33.43-48L172.31,81A4.32,4.32,0,0,0,171,77.82L159.84,65.9c-.53-.5-35.56-13.43-35.56-13.43a4,4,0,0,0-5.22,2L112.94,68c-3,6.69-3.13,36.62-1.91,41h0l.07.16c.48,1.61,14.93,38.28,26.23,59a8.86,8.86,0,0,0,9.84,4.39c13.7-3.26,25.75-8.7,35.83-18.61a2.54,2.54,0,0,0,.35-.46Zm-54.74,22.12a5.19,5.19,0,0,1-6.32-2.8l-19.63-43.09a8.89,8.89,0,0,1,4.39-11.78c1.32-.6,4-1.64,6.73-2.7a12.93,12.93,0,0,1,15.25,4.71l19.68,28.25a13,13,0,0,1-2.47,17.49A55.31,55.31,0,0,1,149.22,161.33Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoDigital);
export default __webpack_public_path__ + "static/media/go_digital.153c610274c2f168fa97d9d159af2e2d.svg";
export { ForwardRef as ReactComponent };